import { LoginOperations } from '../../models/login-operations.entity'
import { SharkBackupLogs } from '../../models/shark-backup-logs.entity';
import { SharkVersionStatistics } from '../../page/shark-version-statistics/shark-version-list';
import http, { HttpSuccessOrErrorType, ListGetRequestParams, ListResults } from '../http'

export default {
    /**
     * 登录日志
     * @param params
     * @returns
     */
    async get_login_operations(params: ListGetRequestParams<{
        start_time: string;
        end_time: string;
    }>): Promise<HttpSuccessOrErrorType<ListResults<LoginOperations>[]>> {
        return await http.get('/get/login/operations', {
            params
        })
    },

    /**
     * shark登录日志
     * @param params
     * @returns
     */
    async get_shark_login_logs(params: ListGetRequestParams<{
        start_time: string;
        end_time: string;
    }>): Promise<HttpSuccessOrErrorType<ListResults<LoginOperations>[]>> {
        return await http.get('/shark/login_logs', {
            params
        })
    },

    /**
     * shark版本分析
     * @param params
     * @returns
     */
    async get_shark_version_statistics(params: {
        start_time: string;
        end_time: string;
    }): Promise<HttpSuccessOrErrorType<SharkVersionStatistics>> {
        return await http.get('/shark_version/statistics', {
            params
        })
    },

    /**
     * shark版本列表
     * @param params
     * @returns
     */
    async get_shark_version_list(params: ListGetRequestParams<{
        start_time: string;
        end_time: string;
    }>): Promise<HttpSuccessOrErrorType<ListResults<LoginOperations>[]>> {
        return await http.get('/shark_version/list', {
            params
        })
    },
    /**
     * shark 备份日志
     * @param params
     * @returns
     */
    async get_shark_backup_logs(params: ListGetRequestParams<{
        start_time: string;
        end_time: string;
    }>): Promise<HttpSuccessOrErrorType<ListResults<SharkBackupLogs>[]>> {
        return await http.get('/oss/logs', {
            params
        })
    }
}